import EventBus from '@/adready-vue/helpers/global/event-bus';
import { isBlank } from 'adready-api/helpers/common';
import { get } from 'vuex-pathify';
import advertiserReportsAPI from '~/api/advertiser-reports';
import { KEY_DEMO_ADVERTISER_ID } from '~/constant';
import { buildQueryString } from '~/helpers/global/url-helpers';
// import { getCampaignDateRange, isDemoInstance, isFlamingoInstance } from '~/util/utility-functions';
import { isDemoInstance, isFlamingoInstance } from '~/util/utility-functions';

const computed = {
  dates: get('dashboard/dates'),
  demoAdvertisers: get('common/GET_DEMO_ADVERTISER_MAPPING_MAP'),
};

const methods = {
  async fetchIos() {
    EventBus.iosReady = false;
    try {
      if (
        !this.account ||
        !this.advertiser ||
        isBlank(this.account.name) ||
        isBlank(this.advertiser.name)
      ) {
        this.$store.set('dashboard/filters@ioOptions', []);
        this.$store.set('dashboard/filters@adGroupOptions', []);
        EventBus.iosReady = true;
        return;
      }
      const campaigns = await advertiserReportsAPI.ioNames(
        this.advertiser ? this.advertiser.id : 0,
        buildQueryString({
          advertiser: this.advertiser ? this.advertiser.name : '',
          client: this.account ? this.account.name : '',
          includeNonFlip: isFlamingoInstance(),
          currentPage: 'Report',
        })
      );
      if (!campaigns.length) {
        this.$store.set('dashboard/filters@ioOptions', []);
        this.$store.set('dashboard/filters@adGroupOptions', []);
        EventBus.iosReady = true;
        return;
      }
      // Mark recent campaigns as default checked
      const advertiserKeys = Object.keys(this.demoAdvertisers).map((k) => parseInt(k, 10));
      const demoAdvertiserId = parseInt(localStorage.getItem(KEY_DEMO_ADVERTISER_ID), 10);
      const demoAdvertiserMappingArr = advertiserKeys?.includes(demoAdvertiserId)
        ? this.demoAdvertisers[demoAdvertiserId]
        : this.demoAdvertisers[1691];

      let demoAdvertiserMapping;
      if (Array.isArray(demoAdvertiserMappingArr) && demoAdvertiserMappingArr.length > 0) {
        demoAdvertiserMapping = demoAdvertiserMappingArr.find((m) => m.solutionId === 1);
        if (!demoAdvertiserMapping) {
          [demoAdvertiserMapping] = demoAdvertiserMappingArr;
        }
      } else {
        demoAdvertiserMapping = undefined;
      }

      // Mark recent campaigns as default checked
      if (isDemoInstance() && demoAdvertiserMapping?.selectedCampaign) {
        for (let i = 0; i < campaigns.length; i++) {
          if (demoAdvertiserMapping?.selectedCampaign?.includes(campaigns[i].value)) {
            campaigns[i].checked = true;
          } else {
            campaigns[i].checked = false;
          }
        }
      } else {
        for (let i = 0; i < campaigns.length; i++) {
          campaigns[i].checked = campaigns[i].isRecent;
        }
      }
      this.$store.set('dashboard/filters@ioOptions', campaigns);
      // if (!isDemoInstance()) {
      //   const dateRange = getCampaignDateRange(campaigns, true);
      //   this.$store.set('dashboard/dates', {
      //     ...this.dates,
      //     ...dateRange,
      //   });
      // }

      if (campaigns.length > 0) {
        const planIds =
          campaigns
            .filter((e) => e.checked)
            ?.map((e) => e.key)
            ?.join(',') || '';
        this.fetchAdGroupOptions(planIds);
      }
    } catch (err) {
      this.$store.set('dashboard/filters@ioOptions', []);
      this.$store.set('dashboard/filters@adGroupOptions', []);
      console.error('error fetching ios ->', err);
      if (window.$sentry) {
        if (err._reported !== true) {
          window.$sentry.captureException(err);
          err._reported = true;
        }
      }
      EventBus.iosReady = true;
      throw err;
    }
  },
  async fetchAdGroupOptions(planIds) {
    const adGroupData = await advertiserReportsAPI.adGroupOptions(
      this.advertiser ? this.advertiser.id : 0,
      buildQueryString({ planIds })
    );
    if (adGroupData?.data?.length > 0) {
      for (let i = 0; i < adGroupData.data.length; i++) {
        adGroupData.data[i].checked = true;
        adGroupData.data[i].value = adGroupData.data[i].lineItemName;
      }
      this.$store.set(
        'dashboard/filters@adGroupOptions',
        adGroupData?.data?.length > 0 ? adGroupData.data : []
      );
      EventBus.iosReady = true;
    } else {
      this.$store.set('dashboard/filters@adGroupOptions', []);
      EventBus.iosReady = true;
    }
  },
};

export default { methods, computed };
